<template>
  <div class="base-phone-wrapper">
    <el-select v-model="countryCode" class="country-prepend" :disabled="disabled">
      <el-option v-for="(item, index) in countryCodeOpt" :key="index" :label="item.name" :value="item.code"/>
    </el-select>
    <template v-if="!isRemote">
      <el-input v-model="phoneNumber"
                class="base-input-phone"
                @change="onChange"
                @input="inputHandle"
                :maxlength="maxlength"
                :placeholder="placeholder"
                type="tel"
                :disabled="disabled"/>
    </template>
    <template v-else>
      <el-autocomplete v-model="phoneNumber"
                       class="base-input-phone"
                       :maxlength="maxlength"
                       valueKey="mobile"
                       @input="inputHandle"
                       @select="onChange"
                       :fetch-suggestions="fetchSuggestions"
                       :placeholder="placeholder"
                       :disabled="disabled"/>
    </template>
  </div>
</template>

<script>

export default {
  name: 'BasePhoneInput',
  props: {
    value: {
      type: [String, Number],
      default: '',
    },
    // 禁止编辑
    disabled: {
      type: Boolean,
      default: false,
    },
    maxlength: {
      type: [String, Number],
      default: 11
    },
    placeholder: String,
    isRemote: {
      type: Boolean,
      default: false,
    },
    fetchSuggestions: Function
  },
  data() {
    return {
      countryCodeOpt: [{ name: '+20', code: '20' }],
    }
  },
  computed: {
    // 电话国家码
    countryCode: {
      get() {
        let countryCode = this.countryCodeOpt[0].code
        if (this.value) {
          countryCode = this.value.substring(this.value.indexOf('+') + 1, this.value.indexOf('-'))
        }
        return countryCode
      },
      set(val) {
        this.$emit('input', `+${val}-${this.phoneNumber}`)
      },
    },
    // 电话
    phoneNumber: {
      get() {
        return this.value ? this.value.substring(this.value.indexOf('-') + 1, this.value.length) : ''
      },
      set(val) {
        this.$emit('input', this.countryCode && val ? `+${this.countryCode}-${val}` : val)
      },
    },
  },
  methods: {
    inputHandle(e) {
      this.phoneNumber = e
    },
    onChange(val) {
      this.$emit('select', val)
    },
  },
}
</script>

<style lang="scss" scoped>
$preWidth: 70px;
$inputWidth: 150px;

.base-phone-wrapper {
  min-width: 232px;

  ::v-deep .el-input {
    .el-input__inner {
      border-radius: 0;

      &:hover:not([disabled]) {
        border-color: #c4c8cc;
      }

      &:focus:not([disabled]) {
        border-color: #c4c8cc;
      }
    }
  }

  .country-prepend {
    width: $preWidth !important;
    display: inline-block;
    border: none !important;

    ::v-deep .el-input {
      .el-input__inner {
        border-top-left-radius: 5px;
        border-bottom-left-radius: 5px;
      }
    }
  }

  .country-prepend {
    ::v-deep .el-input {
      width: $preWidth !important;
    }
  }

  .base-input-phone {
    width: $inputWidth !important;
    display: inline-block;

    ::v-deep .el-input__inner {
      border-left: 0;
      border-top-right-radius: 5px;
      border-bottom-right-radius: 5px;
    }
  }
}
</style>
